module.exports = __webpack_public_path__ + "img/18091680880645_.pic.2e3842f4.jpg";